import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "x-list-item"
};
const _hoisted_2 = {
  class: "item-title"
};
const _hoisted_3 = {
  class: "item-summary"
};
const _hoisted_4 = {
  class: "item-extra"
};
import { toRefs } from 'vue';
export default {
  __name: 'xListItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    summary: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const {
      title,
      summary,
      extra
    } = toRefs(props);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(_unref(title)), 1)])]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "summary", {}, () => [_createTextVNode(_toDisplayString(_unref(summary)), 1)])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "extra", {}, () => [_createTextVNode(_toDisplayString(_unref(extra)), 1)])])]);
    };
  }
};